<div class="text-lg">
  {{ label() | resolveTranslateAbleText }}
  @if (required()) {
    <span> *</span>
  }
</div>
